import {
    EDIT_INSTANCE_FORM_NAME,
    getOrganizationIdFromLocation,
    getUserDetailIdFromLocation
} from "./shared";

import React from "react";
import {connect} from "react-redux";
import {
    compose,
    withHandlers,
    lifecycle
} from "recompose";

import {map, isEmpty, find, forEach} from "lodash";

import { Button } from "react-md";
import {reduxForm, Field, FieldArray} from "redux-form";
import SelectField from "../../../components/form/SelectField";
import {setDialog} from "../../../actions/dialogActions";
import {
    InfoBox,
    InfoBox_Field,
    InfoBox_TextField,
    TouchPageHeader,
    TouchPageHeader_and_content_spaceBetween
} from "../../../AtollonTheme/ReactElements";
import Header from "../../../components/ContainerHeader";

import {setActiveForm} from "../../../actions/appActions";
import {
    getPerson,
    getOrganizationUserDetail,
    setOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser
} from "../../../actions/resourceActions";
import {} from "../../../actions/requestActions";

import * as workInProgress from "../../messages/UserMessages";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import {XMLEditor} from "../../utilities/XmlEditor";
import {DebugElement} from "../../debug";


const InstanceUserDetail_Editor_AsReact = ({
                                               handleSubmit,
                                               // history,
                                               // person,
                                               // userOrganizations,
                                               // organizationUserDetails,
                                               location,
                                               // title,
                                               // organizationUsers,
                                               // organizationUsersAdmin,
                                               // organizationUsersOwner,
                                               // organizationUsersUser,
                                               // setDialog,
                                               activeForm,
                                               setActiveForm,
                                               initialValues,
                                               commonTitle,
                                               instanceUser
                                           }) => {
    let organizationUserDetails = {};
    let userDetailId = 0;
    let userXmlAsString = organizationUserDetails[userDetailId];
    let userXml = xml_utilities.xml_from_string_dontThrowExceptions( userXmlAsString );


    if( activeForm === EDIT_INSTANCE_FORM_NAME )
    {
        return(
            <div>

                <TouchPageHeader title={commonTitle} />
                <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

                <InfoBox>

                    <h1>Editace uživatele instance</h1>

                    <form  onSubmit={handleSubmit} className="">

                        <InfoBox_TextField
                            name={Translate("Uživatelské jméno", "Uživatelské jméno")}
                            value={instanceUser.userDetail_get_userName()}
                        />

                        {/*
                        <Field
                            component={TextField}
                            label="Uživatelské jméno (//userName)"
                            name="userName"
                            validate={[Validation.required]}
                        />

                        */}
                        <InfoBox_TextField
                            name={Translate("Jméno", "Jméno")}
                            value={instanceUser.userDetail_get_contactName()}
                        />

                        <Field
                            component={SelectField}
                            label={Translate("Profil uživatele","Aktivní")}
                            name={"active"}
                            menuItems={
                                [
                                    {label: "ano", value: "true"},
                                    {label: "ne", value: "false"}
                                ]
                            }
                        />

                        {/*

                        <FieldArray
                            component={SelectField}
                            label={Translate("Skupiny", "Skupiny")}
                            name={"group"}
                            menuItems={map(userDetail_get_GROUP(), groupInfo => {
                                    return (
                                        {
                                            label: userDetail_get_GROUP_name( groupInfo ),
                                            value: userDetail_get_GROUP_id( groupInfo )
                                        }
                                    );
                                }
                            )}
                        />

                        <Field
                            component={SelectField}
                            label={Translate("Role", "Role")}
                            name={"role"}
                            menuItems={map(userDetail_get_ROLE(), roleInfo => {
                                    return (
                                        {
                                            label: userDetail_get_ROLE_name( roleInfo ),
                                            value: userDetail_get_ROLE_id( roleInfo )
                                        }
                                    );
                                }
                            )}
                        />

                        <Field
                            component={TextField}
                            label={Translate("Profil uživatele","Profil uživatele")}
                            name={"profileName"}
                            value={userDetail_get_profileName()}
                        />

                        <Field
                            component={TextField}
                            label={Translate("Je admin?","Je admin?")}
                            name={"canSeeAdminTree"}
                            value={yesNo(userDetail_get_canSeeAdminTree())}
                        />

                        <Field
                            component={SelectField}
                            label={Translate("Typ uživatele","Typ uživatele")}
                            name={"isPublicUser"}
                            menuItems={[
                                {label:Translate("Externí uživatel","Externí uživatel"), value:"false"},
                                {label:Translate("Power user","Power user"), value:"true"}
                            ]}
                        />
                        */}

                        {/* value={!userDetail_get_isPublicUser()? "Externí uživatel" : "Power user" */}

                        <br />
                        <br />
                        <br />

                        <Button
                            raised
                            className="btn"
                            label="Zrušit editaci"
                            onClick={() => setActiveForm(null)}
                        />

                        <Button
                            type="submit"
                            primary
                            raised
                            className="btn btn-primary"
                            label="Uložit"
                        />

                    </form>
                </InfoBox>
            </div>
        );
    }
    else
    {
        return (
            <DebugElement text={"InstanceUserDetail -- PASS"}/>
        );
    }
};


/**
 *
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 *
 *
 */


export const InstanceUserDetail_Editor_AsReduxObject = (compose(
    connect(({
                 app: {
                     form: {
                         activeForm
                     }
                 },
                 resource: {
                     person,
                     organizationUserDetails,
                     organizationUsers,
                     organizationUsersAdmin,
                     organizationUsersOwner,
                     organizationUsersUser
                 }
             }) => ({
        activeForm,
        person,
        organizationUserDetails,
        organizationUsers,
        organizationUsersAdmin,
        organizationUsersOwner,
        organizationUsersUser
        // ,
        // initialValues: {
        //     userName: 'user name set from connect() ',
        //     contactName: 'contact name from connect()'
        // }
    }), {
        getPerson,
        getOrganizationUserDetail,
        getOrganizationUsers,
        getOrganizationUsersAdmin,
        getOrganizationUsersOwner,
        getOrganizationUsersUser,
        setDialog,
        setActiveForm,
        setOrganizationUserDetail
    }),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) => {

            let { location, getOrganizationUserDetail, setOrganizationUserDetail, organizationUserDetails } = props;

            console.log( '%csubmit', 'background:red;color:#fff;', formData, arguments );

            //
            // get user as xml string
            //
            let errorMessage =  '';
            let organizationId = getOrganizationIdFromLocation( location );
            let userId = getUserDetailIdFromLocation(location);
            if( organizationUserDetails && organizationUserDetails[userId] )
            {
                let userXMLAsString;
                userXMLAsString = organizationUserDetails[userId];
                if( userXMLAsString )
                {
                    console.log('InstanceUserDetail parsed information', {organizationId, userId});

                    //
                    // edit all parameters in xml
                    //
                    let editor = new XMLEditor();
                    if( editor.setXMLString( userXMLAsString ))
                    {
                        let allParametersAddedOk = true;
                        if( ! editor.changeOrCreateElement( 'active', formData.active )){ allParametersAddedOk = false; }
                        if( ! editor.changeOrCreateElement( 'forwardingEmail', formData.forwardingEmail )){ allParametersAddedOk = false; }

                        if( allParametersAddedOk )
                        {
                            let editedXMLAsString = editor.getXML();
                            if( editedXMLAsString )
                            {
                                await setOrganizationUserDetail(organizationId, userId, editedXMLAsString );
                                await getOrganizationUserDetail(organizationId, userId);
                            }
                            else
                            {
                                errorMessage = 'Chyba při ukládání uživatele instance (5)';
                            }
                        }
                        else
                        {
                            errorMessage = 'Chyba při ukládání uživatele instance (4)';
                        }
                    }
                    else
                    {
                        errorMessage = 'Chyba při ukládání uživatele instance (3)';
                    }
                }
                else
                {
                    errorMessage = 'Chyba při ukládání uživatele instance (2)';
                }
            }
            else
            {
                errorMessage = 'Chyba při ukládání uživatele instance (1)';
            }

            if( errorMessage )
            {
                workInProgress.userMessage_throwErrorToFieldNamed( 'Editace uživatele instance', errorMessage );
            }
            else
            {
                workInProgress.userMessage_ok( 'Editace uživatele instance', 'Uloženo' );
            }

            // debugger;

            // return;
            //
            // const {hostId, serverId, createMyAtollonInstance, history, users} = props;
            //
            // let createInstanceParameters = {};
            // createInstanceParameters.name = formData.name;
            // createInstanceParameters.ident = formData.ident;
            // if (!serverChoosesCategory) {
            //     createInstanceParameters.serverCategory = formData.serverCategory;
            // }
            // createInstanceParameters.productName = formData.productName;
            // createInstanceParameters.productLocale = formData.productLocale;
            //
            //
            // function testingData() {
            //     createInstanceParameters.name = "moje krásná  nová instance  organizace23";
            //     createInstanceParameters.ident = "ident23";
            //     createInstanceParameters.serverCategory = "rct-shared";
            //     createInstanceParameters.productName = "productName23";
            //     createInstanceParameters.productLocale = "en";
            // }
            //
            // if (
            //     await createMyAtollonInstance(createInstanceParameters)
            // ) {
            //     workInProgress.userMessage_ok("Instance založena");
            //     // history.push(`/hosts/${hostId}/${serverId}`);
            // } else {
            //     workInProgress.userMessage_throwErrorToFieldNamed('billingContact', "Instance nebyla založena");
            // }
        }
    }),
    lifecycle({
        async componentWillMount() {
        }
    }),
    reduxForm({
        form: EDIT_INSTANCE_FORM_NAME,
        enableReinitialize: true
    })
)(InstanceUserDetail_Editor_AsReact));



// WEBPACK FOOTER //
// ./src/Atollon/pages/InstanceUserDetail/InstanceUserDetail_Editor.js